import axios from "axios";

import { BASE_URL } from "../../src/utils/api_base_url_configration";


export const getProductLocationServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "product-manufacture-location/list", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const addProductLocationServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "product-manufacture-location/create", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const updateProductLocationServ = async (formData) => {
  try {
    const response = await axios.put(BASE_URL + "product-manufacture-location/update", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const deleteProductLocationServ = async (id) => {
  try {
    const response = await axios.delete(BASE_URL + "product-manufacture-location/delete/"+id);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
